import { render, staticRenderFns } from "./Indent.vue?vue&type=template&id=be4aa43a"
import script from "./Indent.vue?vue&type=script&lang=js"
export * from "./Indent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports